import React from 'react';
import { Box, Typography } from '@mui/material';
import useAppNavigation from '../../../hooks/useAppNavigation';

export default function DashboardWelcomeHeader({ styles }) {
  const { displayName } = useAppNavigation();

  return (
    <Box sx={styles.welcomeSection}>
      <Typography component="h1" sx={styles.welcomeTitle}>
        Welcome back, {displayName}
      </Typography>
      <Typography sx={styles.welcomeSubtitle}>
        Build, automate and scale your ideas with Machadalo.
      </Typography>
    </Box>
  );
}
